import React from "react";

export const ExpressionTestResultColorContext = React.createContext<string | undefined>(undefined);
